// extracted by mini-css-extract-plugin
export default {"campaign-popup-desc-wrapper":"campaign-popup-desc-wrapper_sO914","button-group":"button-group_mJ4yt","user-ids-box":"user-ids-box_IVdBC"};